import { InfiniteData, QueryClient } from '@tanstack/react-query';

import { GetRewardPoolsData } from '@shared/api/rewardPools';
import { RewardPool } from '@shared/api/types/rewardPools';
import { ALL_REWARD_POOLS_INFINITE_QUERIES_KEY } from '@shared/hooks/query/rewardPools';

type Props = {
  poolId: number;
  key: keyof Pick<RewardPool, 'participants_counter' | 'entries_counter'>;
  increment: number;
  queryClient: QueryClient;
};

export const incrementPoolCounter = ({ poolId, key, increment, queryClient }: Props) => {
  queryClient.setQueriesData(
    {
      queryKey: [ALL_REWARD_POOLS_INFINITE_QUERIES_KEY],
    },
    (data?: InfiniteData<GetRewardPoolsData>) => {
      if (!data) {
        return data;
      }

      return {
        ...data,
        pages: data.pages.map((page) => {
          return {
            ...page,
            pools: page.pools.map((pool) => {
              const prevValue = pool[key];

              if (pool.id === poolId && prevValue !== null) {
                return {
                  ...pool,
                  [key]: prevValue + increment,
                };
              }

              return pool;
            }),
          };
        }),
      };
    },
  );
};
